import type { BadgeStyleParams } from '@atoms/badges/badgeStyle';

export const BATCHES_STATUS = {
  RECEIVED: 'received',
  WAITING_REVIEW: 'waiting_review',
  PROCESSING: 'processing',
  REJECTED: 'rejected',
  COMPLETED: 'completed'
} as const;

export type BatchState = {
  id: string;
  value: (typeof BATCHES_STATUS)[keyof typeof BATCHES_STATUS] | string;
  order: number;
  label: string;
  style: BadgeStyleParams;
};
